import { StorageManager } from '@funtech-int/web-toolkit';

import {
    IS_PROFILE_FAMILY_CHOICE_SUPPRESSED_KEY,
    PROFILE_SESSION_TIMESTAMP,
    SUBSCRIPTION_PURCHASE_SESSION_TIMESTAMP,
} from '@/shared/lib/profileSession';

const PROFILE_SESSION_IDLE_DELTA = 1000 * 60 * 60 * 24 * 3; // 3 days

function isProfileChoiceBlocked(storage: StorageManager) {
    return Boolean(storage.local.get(IS_PROFILE_FAMILY_CHOICE_SUPPRESSED_KEY)) || false;
}

function isProfileSessionExpired(storage: StorageManager): boolean {
    const nowTimestamp = new Date().getTime();

    const timestamp = Number(storage.local.get(PROFILE_SESSION_TIMESTAMP));

    if (Number.isNaN(timestamp)) {
        return true;
    }

    return nowTimestamp - timestamp > PROFILE_SESSION_IDLE_DELTA;
}

const SUBSCRIPTION_PURCHASE_SESSION_IDLE_DELTA = 1000 * 60 * 60; // 1 hour

// Нужно для того чтобы откладывать показ экрана после покупки подписки
function isSubscriptionPurchaseSessionExpired(storage: StorageManager): boolean {
    const nowTimestamp = new Date().getTime();

    const timestamp = Number(storage.local.get(SUBSCRIPTION_PURCHASE_SESSION_TIMESTAMP));

    if (Number.isNaN(timestamp)) {
        return true;
    }

    return nowTimestamp - timestamp > SUBSCRIPTION_PURCHASE_SESSION_IDLE_DELTA;
}

export function getIsProfilesPageSuppressed(storage: StorageManager) {
    return (
        isProfileChoiceBlocked(storage) ||
        !isProfileSessionExpired(storage) ||
        !isSubscriptionPurchaseSessionExpired(storage)
    );
}
